import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { ErrorDialogComponent } from './dialog'
import { ErrorComponent } from './error.component'
import { ErrorEffects } from './store/error.effects'

import { CommonModule } from '@angular/common'

@NgModule({
  exports: [ErrorComponent],
  imports: [
    CommonModule,
    EffectsModule.forFeature([ErrorEffects]),
    ErrorComponent,
    ErrorDialogComponent,
  ],
})
export class ErrorModule {}
